import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/useAuth';
import { useMinShow } from '@/hooks/useMinShow';
import FullScreenLoader from '@/components/ui/FullScreenLoader';
import { AUTH_ENABLED } from '@/lib/prelaunch';

export default function OnboardingRoute() {
  const { session, isAuthLoading } = useAuth();
  const showLoader = useMinShow(isAuthLoading, 1400);

  if (showLoader) return <FullScreenLoader />;
  if (!session) return <Navigate to={AUTH_ENABLED ? '/auth' : '/'} replace />;
  return <Outlet />;
}
